module.exports = __webpack_public_path__ + "img/team1.4956c605.png";